// extracted by mini-css-extract-plugin
module.exports = {"task-order":"task-order-f3be97d943afdbf79181f0b615b4c88e"};